import * as React from 'react'

import { config } from '../../../../../common/config'
import { ISeoItem } from '../../../../../typings/seoMetadata'
import Button from '../../../../v0/components/button'
import PageSection from '../pageSection'
import SectionDescription from '../sectionDescription'

import * as styles from './communitySection.module.css'

interface IProps {
  metadata: ISeoItem
}

const CommunitySection = ({ metadata }: IProps) => {
  return (
    <div data-test-selector="communitySection">
      <PageSection borderTop darkBackground>
        <SectionDescription metadata={metadata} HTag="h3" />
        <div className={styles.buttonSection}>
          <Button primary href="https://forums.envato.com/">
            Visit Our Forums
          </Button>
        </div>
        <div>
          <img
            alt="vist our forums"
            src={`${config.assets.PUBLIC_PATH}/images/home-page/community.png`}
            className={styles.img}
          />
        </div>
      </PageSection>
    </div>
  )
}

export default CommunitySection
